import React, { useState, useEffect, useRef, Fragment } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { Spin } from 'antd';
import { connect } from 'react-redux';

import { config } from '../../constant';
import ReactEcharts from '../../Echarts/Echarts';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { heatmapCartesionMockJson1 } from '../../../Mock/heatmapMock';

const HeatmapCartesion = (props) => {
  const [option, setOption] = useState({});
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    translationCache,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData();
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear,
    props.translationCache
  ]);

  const getOption = () => {
    let rangeValue = [];
    if (graphprops && graphprops[graphprops.graph] && graphprops[graphprops.graph].range) {
      const rangeValue1 = graphprops && graphprops[graphprops.graph] && graphprops[graphprops.graph].range ? graphprops[graphprops.graph].range : [];
      rangeValue = JSON.parse(rangeValue1);
    }

    return {
      grid: {
        left: '10%',
        width: '87%'
      },
      tooltip: {
        position: 'top',
        textStyle: {
          color: props.theme.algorithm === "dark" ? 'white' : 'black',
          fontSize: 16
        },
        formatter: (param) => {
          let xAxisLabel = translationCache && translationCache[param.name] ? translationCache[param.name] : param.name;
          let actualValue = translationCache && translationCache['Actual Value'] ? translationCache['Actual Value'] : 'Actual Value';
          let predictedValue = translationCache && translationCache['Predicted Value'] ? translationCache['Predicted Value'] : 'Predicted Value';
          if (graphprops && graphprops[graphprops.graph] && graphprops[graphprops.graph].cartesionDisplayType === 'percentage') {
            return [
              param.marker,
              ` <bold>${xAxisLabel}</bold>`,
              `: ${param.data[5]}%`,
              '\n\n',
              ` <bold>${actualValue}: ${param.value[2]}</bold>${predictedValue}: ${param.data[3]}`
            ].join(' <br/> ');
          } else if (param.data[5] === 1) {
            return [` <bold>${param.marker} <bold>${xAxisLabel}</br>${param.data[4]}</bold>`];
          }
        }
      },
      animation: true,
      xAxis: {
        type: 'category',
        splitArea: {
          show: true
        },
        axisLabel: {
          textStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black',
            fontSize: 13
          }
        },
        axisTick: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        },
        axisLine: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        }
      },
      yAxis: {
        type: 'category',
        splitArea: {
          show: true
        },
        axisLabel: {
          textStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black',
            fontSize: 13
          }
        },
        axisTick: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        },
        axisLine: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        }
      },
      visualMap: [{
        calculable: true,
        orient: 'horizontal',
        show: graphprops && graphprops[graphprops.graph] && graphprops[graphprops.graph].rangeBar && (graphprops[graphprops.graph].rangeBar === 'true' || graphprops[graphprops.graph].rangeBar === true) ? true : false,
        top: '1%',
        left: '65%',
        min: rangeValue && rangeValue[0] ? rangeValue[0] : 0,
        max: rangeValue && rangeValue[1] ? rangeValue[1] : 1,
        textStyle: {
          color: props.theme.algorithm === "dark" ? 'white' : 'black',
          fontWeight: 'bold',
          fontSize: 16
        },
        pieces: graphprops && graphprops[graphprops.graph] && graphprops[graphprops.graph].VisualMap ? graphprops[graphprops.graph].VisualMap : [],
        outOfRange: {
          color: '#0d1115'
        },
        inRange: {
          color: ['#f5d191', 'red']
        }
      }],
      series: [],
      toolbox: {
        showTitle: false,
        orient: 'vertical',
        itemSize: 25,
        feature: {
          saveAsImage: {
            title: 'download',
            backgroundColor: props.theme.algorithm === "dark" ? 'black' : 'white',
            name: graphprops.title,
            iconStyle: {
              borderColor: '#8c8c8c',
              borderWidth: 2
            }
          }
        }
      }
    };
  };

  const getData = async () => {
    let errorFlag = false;
    let noDataFlag = false;
    let series = [];
    const { graphprops } = props;

    let displayType =
      props &&
      props.graphprops &&
      props.graphprops[graphprops.graph] &&
      props.graphprops[graphprops.graph].cartesionDisplayType;

    let json = {};
    let optionLocal = getOption();

    setLoading(true);

    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = heatmapCartesionMockJson1;
      requestCheck.current = true;

      setLoading(false);
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
          setLoading(false);
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
          setLoading(false);
        }
      }
    }

    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        errorFlag = true;
      } else if (json.length === 0) {
        noDataFlag = true;
      }
    } else {
      let time = [];
      let dataLocal = [];
      let mainDataObject = [];

      let jsonTimeData =
        json &&
        Array.isArray(json) &&
        json.map((jsonTime) => {
          return moment.utc(jsonTime.DateTime).tz(props.currentTimeZone).format('HH:mm:ss');
        });
      jsonTimeData = _.uniq(jsonTimeData);
      let jsonNew = {};
      jsonTimeData.map((jsonObject) => {
        let JSONData = json.filter(
          (e) =>
            moment.utc(e.DateTime).tz(props.currentTimeZone).format('HH:mm:ss') === jsonObject
        );
        let newJSON = JSONData.map((data) => {
          return {
            ...data,
            DateTime: moment.utc(data.DateTime).tz(props.currentTimeZone).format('YYYY-MM-DD HH:mm:ss'),
          };
        });

        jsonNew[jsonObject] = newJSON;
        return null;
      });
      json = jsonNew;
      // json = {
      //   "6 to 10 mins for 4.3 Mpa": [
      //     {
      //       "DateTime": "2025-09-02 00:00:00",
      //       "Value": 0
      //     },
      //     {
      //       "DateTime": "2025-09-03 00:00:00",
      //       "Value": 0
      //     },
      //     {
      //       "DateTime": "2025-09-04 00:00:00",
      //       "Value": 0
      //     },
      //     {
      //       "DateTime": "2025-09-05 00:00:00",
      //       "Value": 0
      //     },
      //     {
      //       "DateTime": "2025-09-06 00:00:00",
      //       "Value": 0
      //     },
      //     {
      //       "DateTime": "2025-09-07 00:00:00",
      //       "Value": 0
      //     },
      //     {
      //       "DateTime": "2025-09-08 00:00:00",
      //       "Value": 0
      //     }
      //   ],
      //   "11 to 15 mins for 4.25 Mpa": [
      //     {
      //       "DateTime": "2025-09-02 00:00:00",
      //       "Value": 0
      //     },
      //     {
      //       "DateTime": "2025-09-03 00:00:00",
      //       "Value": 0
      //     },
      //     {
      //       "DateTime": "2025-09-04 00:00:00",
      //       "Value": 25
      //     },
      //     {
      //       "DateTime": "2025-09-05 00:00:00",
      //       "Value": 33.33
      //     },
      //     {
      //       "DateTime": "2025-09-06 00:00:00",
      //       "Value": 50
      //     },
      //     {
      //       "DateTime": "2025-09-07 00:00:00",
      //       "Value": 0
      //     },
      //     {
      //       "DateTime": "2025-09-08 00:00:00",
      //       "Value": 100
      //     }
      //   ]
      // }

      if (json && Object.keys(json).length > 0) {
        time = Object.keys(json);
        let timeData = Object.keys(json).map((timeFormat) => {
          return moment(timeFormat, 'HH:mm:ss').format('HH:mm:ss');
        });

        if (time && time.length > 0 && json[time[0]]) {
          dataLocal =
            Array.isArray(json[time[0]]) &&
            json[time[0]].map((yAxis) => {
              return moment(yAxis.DateTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
            });
        }

        let yAxis = [];
        for (let i = 6; i >= 0; i--) {
          yAxis.push(moment(props.selectionDateLive).subtract(i, 'days').format('YYYY-MM-DD'));
        }

        time &&
          time.map((mainObject) => {
            let newObject = [];
            if (json[mainObject] && Array.isArray(json[time[0]])) {
              newObject = dataLocal.map((yAxisData, childKey) => {
                let splitedData = mainObject.split(':');
                let xAxis = '';
                if (displayType && displayType === 'percentage') {
                  xAxis = mainObject;
                } else {
                  xAxis = splitedData.length === 3 ? splitedData[0] + ':' + splitedData[1] : mainObject;
                }
                let allIntervals = {};

                json[mainObject].map((jsonData) => {
                  allIntervals = {
                    ...allIntervals,
                    [moment(jsonData.DateTime).format('YYYY-MM-DD')]: jsonData,
                  };
                  return null;
                });

                if (Object.keys(allIntervals).includes(yAxisData)) {
                  return [
                    childKey,
                    xAxis,
                    allIntervals[yAxisData].Value,
                    allIntervals[yAxisData].actualValue,
                    allIntervals[yAxisData].predictedValue,
                    allIntervals[yAxisData].Description,
                  ];
                }
                return null;
              });
            }
            newObject = newObject.filter((element) => element !== undefined && element !== null);
            mainDataObject = [...mainDataObject, ...(Array.isArray(newObject) ? newObject : [])];
            return null;
          });

        if (mainDataObject && Array.isArray(mainDataObject)) {
          setData(mainDataObject ? mainDataObject : data);
        }

        if (timeData && Array.isArray(timeData) && displayType !== 'percentage') {
          optionLocal.xAxis.data = timeData.map((item) => {
            let splitedData = item.split(':');
            let xAxisData = splitedData.length === 3 ? splitedData[0] + ':' + splitedData[1] : item;
            let xAxis =
              translationCache && translationCache[xAxisData] ? translationCache[xAxisData] : xAxisData;
            return xAxis;
          });
        } else if (displayType === 'percentage') {
          optionLocal.xAxis.data = time;
        }

        if (dataLocal && Array.isArray(dataLocal)) {
          optionLocal.yAxis.data =
            props.graphprops &&
              props.graphprops[graphprops.graph] &&
              props.graphprops[graphprops.graph].cartesionDisplayType === 'none'
              ? yAxis
              : dataLocal.map((item) => item);
        }

        series = [
          {
            name: '',
            type: displayType === 'scatter' ? 'scatter' : 'heatmap',
            symbolSize: 15,
            itemStyle: {
              borderWidth: 2,
              borderType: 'dotted',
              borderColor: 'rgba(187, 177, 177, 1)',
            },
            data:
              mainDataObject &&
              Array.isArray(mainDataObject) &&
              mainDataObject.map((item) => {
                if (item) {
                  return [
                    item[1],
                    item[0],
                    item[3] || 0,
                    item[4] || 0,
                    item[5] ? item[5] : '',
                    item[2] || item[2] === 0 ? item[2] : '-',
                  ];
                }
                return null;
              }),
            label: {
              show: displayType === 'none' ? false : true,
              textStyle: {
                color: props.theme.algorithm === "dark" ? 'white' : 'black',
                fontSize: 12,
              },
              formatter: function (params) {
                if (displayType === 'percentage') {
                  return params.value[5] + '%';
                }
                return params.value[5];
              },
              color: '#000',
            },
          },
        ];
      }

      optionLocal.series = series;
      setOption(optionLocal);
      setRefreshDateTime(refreshDateTime);
    }

    setErrorInAPI(errorFlag);
    setNoDataInDB(noDataFlag);

  };


  return (
    <span>
      {!loading ? (
        <Fragment>
          {noDataInDB || errorInAPI ? (
            noDataInDB ? (
              <NoRecordComponent />
            ) : (
              <ErrorComponent />
            )
          ) : (
            <ReactEcharts
              option={option}
              style={{ height: '80%', width: '100%' }}
            />
          )}
        </Fragment>
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%'
          }}
        >
          <Spin spinning={loading} tip="Loading..." />
        </div>
      )}
    </span>
  );
};
const mapStateToProps = (state) => {
  return {
    theme: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone
  };
};
export default connect(mapStateToProps)(HeatmapCartesion);
